import React from "react";

const IconMobileApp = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 16 22" fill="none" className={className}>
    <path d="M1 1.3501H4.77V3.6301H10.69V1.3501H15V14.1001H1V1.3501Z" fill="url(#paint0_linear_146_250)" />
    <path
      d="M11 1V2.39999C11 2.95999 11 3.23998 10.89 3.44998C10.79 3.63998 10.64 3.78998 10.45 3.88998C10.24 3.99998 9.96 4 9.4 4H6.6C6.04 4 5.76 3.99998 5.55 3.88998C5.36 3.78998 5.21 3.63998 5.11 3.44998C5 3.23998 5 2.95999 5 2.39999V1M4.2 21H11.8C12.92 21 13.48 21 13.91 20.78C14.29 20.59 14.59 20.28 14.78 19.91C15 19.48 15 18.92 15 17.8V4.19998C15 3.07998 15 2.52 14.78 2.09C14.59 1.71 14.28 1.41 13.91 1.22C13.48 1 12.92 1 11.8 1H4.2C3.08 1 2.52 1 2.09 1.22C1.71 1.41 1.41 1.72 1.22 2.09C1 2.52 1 3.07998 1 4.19998V17.8C1 18.92 1 19.48 1.22 19.91C1.41 20.29 1.72 20.59 2.09 20.78C2.52 21 3.08 21 4.2 21Z"
      stroke="#191E49"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient id="paint0_linear_146_250" x1="8" y1="1.3501" x2="8" y2="14.1001" gradientUnits="userSpaceOnUse">
        <stop stopColor="#C098F5" />
        <stop offset="1" stopColor="#C098F5" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default IconMobileApp;
